import * as globals from '../globals.js';
import swal from 'sweetalert2';

export default class NotificationService {
    static createdInstance = null;
    static getInstance() {
        if (NotificationService.createdInstance === null) {
            NotificationService.createdInstance = new NotificationService();
        }
        return NotificationService.createdInstance;
    }

    constructor() {
        this._toast = swal.mixin({
            toast: true,
            position: 'bottom-end',
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            didOpen: (toast) => {
                toast.addEventListener('mouseenter', swal.stopTimer);
                toast.addEventListener('mouseleave', swal.resumeTimer);
            },
        });
    }

    showSuccess(message, timeout = 5000) {
        if (typeof message === 'string' && typeof timeout === 'number') {
            this._toast.fire({
                icon: 'success',
                title: message,
                timer: timeout,
            });
        } else {
            console.error('incorrect parameters');
        }
    }

    showError(message = globals.DEFAULT_ERROR_MESSAGE, timeout = 10000) {
        if (typeof message === 'string' && typeof timeout === 'number') {
            this._toast.fire({
                icon: 'error',
                title: message,
                timer: timeout,
            });
        } else {
            console.error('incorrect parameters');
        }
    }

    showWarning(message, timeout = 3000) {
        if (typeof message === 'string' && typeof timeout === 'number') {
            this._toast.fire({
                icon: 'warning',
                title: message,
                timer: timeout,
            });
        } else {
            console.error('incorrect parameters');
        }
    }

    showInfo(message, timeout = 3000) {
        if (typeof message === 'string' && typeof timeout === 'number') {
            this._toast.fire({
                icon: 'info',
                title: message,
                timer: timeout,
            });
        } else {
            console.error('incorrect parameters');
        }
    }
}
